import { useEffect, useState } from 'react';
import { Panel } from './Panel';
import { getShowController } from '@/show/saysController';
import { fmtMB } from '@/show/localVideo';
import { cacheBytes, offlineLine } from '@/show/showCache';

export const OfflinePanel = () => {
  const ctrl = getShowController();
  const [snap, setSnap] = useState(ctrl.getSnapshot());
  const [bytes, setBytes] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const off = ctrl.subscribe(() => setSnap(ctrl.getSnapshot()));
    const id = setInterval(() => {
      setSnap(ctrl.getSnapshot());
      cacheBytes().then(setBytes);
    }, 1000);
    return () => {
      off();
      clearInterval(id);
    };
  }, [ctrl]);
  const o = snap.offline;
  const save = async () => {
    setBusy(true);
    await ctrl.saveOffline();
    setBusy(false);
  };
  return (
    <Panel testId="offline-panel" code="13 / OFFLINE" title="Save show to this laptop" right={<button type="button" data-testid="save-show-offline-button" disabled={busy} className="btn-lab px-3 py-1 text-[0.65rem]" onClick={save}>{busy ? 'SAVING…' : 'SAVE SHOW TO THIS LAPTOP'}</button>}>
      <div data-testid="offline-status" data-ready={o.ready} className={`text-sm tracking-[0.15em] ${o.ready ? 'text-[var(--spore)]' : 'text-[var(--amber)]'}`}>{offlineLine(o)}</div>
      <div className="mt-2 grid grid-cols-2 gap-1 text-xs text-[var(--muted)] md:grid-cols-4">
        <span data-testid="offline-voices">VOICES {o.voices}/{o.voicesTotal}</span>
        <span data-testid="offline-sfx">SOUNDS {o.sfx}/{o.sfxTotal}</span>
        <span data-testid="offline-video">VIDEO {o.video ? 'SAVED' : o.videoDl.toUpperCase()}</span>
        <span data-testid="offline-app">APP SHELL {o.app ? 'SAVED' : 'NOT YET'}</span>
        <span data-testid="offline-bytes">ON DISK {bytes ? fmtMB(bytes) : '—'}</span>
        <span>PERSISTENT {o.persisted ? 'YES' : 'ASKING'}</span>
        <span data-testid="offline-network">NETWORK {snap.net.online ? (snap.net.slow ? 'SLOW' : 'ONLINE') : 'OFFLINE'}</span>
        <span data-testid="offline-outbox">OUTBOX {snap.net.outbox}</span>
      </div>
      <p className="mt-2 text-[0.65rem] text-[var(--dim)]">Saved automatically on the landing page. On later loads the laptop copy plays first; a newer pinned script / sound bank is downloaded in the background and swapped in on the landing page only, never mid-show.</p>
    </Panel>
  );
};
